export default function IosPaw() {
  return (
    <div
      className="ion-icon-ios-paw"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M443.827,195.5c-4.383-11.73-11.753-20.212-21.317-24.524c-4.389-1.975-8.995-2.976-13.688-2.976
		c-20.025,0-40.372,18.667-50.632,46.454c-12.698,34.42-5.315,68.135,17.173,78.423c4.522,2.071,9.365,3.123,14.394,3.123
		c20.396,0,41.126-17.119,51.581-42.596C449.238,234.121,450.168,212.477,443.827,195.5z"/>
	<path d="M153.811,214.454C143.551,186.667,123.204,168,103.179,168c-4.693,0-9.3,1.001-13.689,2.976
		c-9.565,4.312-16.934,12.794-21.317,24.524c-6.341,16.977-5.411,38.621,2.49,57.904C81.118,278.881,101.848,296,122.244,296
		c5.028,0,9.871-1.052,14.394-3.123C159.126,282.589,166.509,248.874,153.811,214.454z"/>
	<path d="M198.347,210.601c1.855,0.081,3.727,0.03,5.563-0.151c10.787-1.059,20.54-6.594,28.207-16.008
		c12.371-15.191,15.806-38.974,13.201-63.439C241.336,93.3,221.469,65.161,194.776,64c0,0-3.811,0.008-5.75,0.193
		c-11.776,1.164-22.481,7.283-30.957,17.695c-12.291,15.101-18.198,37.57-15.803,60.104
		C146.202,179.269,170.836,209.404,198.347,210.601z"/>
	<path d="M256,240c-64,0-128,76.074-128,149.128c0,21.798,10.932,39.331,21.667,46.517C162.925,444.516,172.269,448,191.704,448
		c23.093,0,29.325-8.078,40.136-15.205c7.819-5.152,14.572-9.605,24.161-9.605s16.342,4.453,24.16,9.605
		C290.972,439.922,297.203,448,320.297,448c19.434,0,28.778-3.484,42.036-12.355C373.068,428.459,384,410.926,384,389.128
		C384,316.074,320,240,256,240z"/>
	<path d="M308.281,210.265c1.836,0.182,3.709,0.232,5.563,0.151c27.511-1.196,52.146-31.332,56.081-68.607
		c2.395-22.534-3.514-45.004-15.804-60.104c-8.476-10.412-18.783-16.228-30.56-17.392c-1.939-0.186-6.146-0.312-6.146-0.312
		c-26.693,1.161-46.561,29.115-50.542,66.817c-2.604,24.466,0.83,48.248,13.2,63.439
		C287.741,203.671,297.494,209.206,308.281,210.265z"/>
</g>
</svg>
`,
      }}
    />
  )
}
